import { render, staticRenderFns } from "./ModalCPMContent.vue?vue&type=template&id=6a511382&scoped=true&"
import script from "./ModalCPMContent.vue?vue&type=script&lang=ts&"
export * from "./ModalCPMContent.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCPMContent.vue?vue&type=style&index=0&id=6a511382&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a511382",
  null
  
)

export default component.exports